<template lang="pug">
	.variative-text-param-editor-handler(v-if="false")
</template>

<script>
	export default {
		translationCategory: 'insertion.SSMLVariativeTextEditor',
		name: 'variative-text-param-editor-handler',
		components: {		
		},
		model: {			
		},		
		data() {
			return {				
			};
		},		
		mounted() {
			this.$emit('created');
		}
	};
</script>
<style lang='scss'>	
</style>
